import { ApiClient } from '../../ApiClient';
import { ConnectionDTO } from '../dto/MarketplaceDTOs';
import { InventorySyncEventItem } from '@domain/connection/models/InventorySyncEvent';
import { FullSyncJob } from '@domain/connection/models/ImportJob';
import { ChannelDockAccountType } from '@domain/connection/IMarketplaceRepository';

export class ChannelDockConnectorDataSource {
  constructor(private api: ApiClient) {
  }

  async addConnection(apiKey: string, apiSecret: string, accountType: ChannelDockAccountType): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>('/connections/channeldock', {
      apiKey,
      apiSecret,
      accountType,
    });
    return response.data;
  }

  async reconnect(connectionId: string, apiKey: string, apiSecret: string, accountType: ChannelDockAccountType): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>(`/connections/channeldock/${connectionId}/reconnect`, {
      apiKey,
      apiSecret,
      accountType,
    });
    return response.data;
  }

  async fetchInventory(connectionId: string): Promise<InventorySyncEventItem[]> {
    const response = await this.api.get<InventorySyncEventItem[]>(`/connections/channeldock/inventory`, {
      params: { connectionId },
    });
    return response.data;
  }

  async syncFull(connectionId: string): Promise<FullSyncJob[]> {
    const response = await this.api.post<{ jobs: FullSyncJob[] }>(`/connections/channeldock/sync/full`, null, {
      params: { connectionId },
    });
    return response.data.jobs;
  }
}
